export const editor = {
  colorScheme: {
    light: {
      background: '{surface.100}',
      borderColor: '{primary.400}',
      color: '{paginator.color}',
      navButton: {
        color: 'black',
        selectedColor: 'black',
      },
      toolbar: {
        borderColor: 'transparent',
        background: '#dee2e6',
        color: '',
        item: {
          hoverColor: '#959ba3',
          activeColor: '#4db8ff',
          color: '#575a5f',
        },
      },
      overlay: {
        borderColor: 'transparent',
        background: '#b7bbc1',
        color: 'black',
        item: {
          color: 'black',
        },
      },
      content: {
        borderColor: '#cccccc',
        // background: '#d0d0d0',
        background: '#ffffff',
        color: 'black',
        border: '1px solid #cccccc',
        item: {
          color: '#ffffff',
        },
      },
    },
    dark: {
      color: '#ffffff',

      toolbar: {
        borderColor: 'transparent',
        background: ' #586274',
        color: '#ffffff',
        item: {
          hoverColor: '#b6bdc8',
          activeColor: '#4db8ff',
          color: '#ffffff',
        },
      },
      overlay: {
        borderColor: 'transparent',
        background: '#3C434F',
        color: '#ffffff',
        item: {
          color: '#ffffff',
        },
      },
      overlayOption: {
        borderColor: 'transparent',
        background: '#3C434F',
        color: '#ffffff',
        item: {
          color: '#ffffff',
        },
      },
      content: {
        borderColor: 'transparent',
        background: '#333842',
        color: '#ffffff',
        item: {
          color: '#ffffff',
        },
      },
    },
  },
};
